import { createSlice } from '@reduxjs/toolkit';

const TOKEN_KEY = 'pulseloop.subscriber_token';

const initialState = {
  subscriber: null,
  token: localStorage.getItem(TOKEN_KEY),
};

const subscriberAuthSlice = createSlice({
  name: 'subscriberAuth',
  initialState,
  reducers: {
    setSubscriberCredentials(state, action) {
      const { subscriber, token } = action.payload;
      if (subscriber !== undefined) state.subscriber = subscriber;
      if (token !== undefined) {
        state.token = token;
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
      }
    },
    subscriberLogout(state) {
      state.subscriber = null;
      state.token = null;
      localStorage.removeItem(TOKEN_KEY);
    },
  },
});

export const { setSubscriberCredentials, subscriberLogout } = subscriberAuthSlice.actions;

export const selectCurrentSubscriber = (state) => state.subscriberAuth.subscriber;
export const selectSubscriberToken = (state) => state.subscriberAuth.token;
export const selectIsSubscriberAuthenticated = (state) => Boolean(state.subscriberAuth.token);

export default subscriberAuthSlice.reducer;
